export { ChatSelectionProvider, useChatSelection } from './ChatIdContext.js';
export type { ChatSelectionContextType } from './ChatIdContext.js';

// Backwards compatibility aliases
export { ChatIdProvider, useChatId } from './ChatIdContext.js';
export type { ChatIdContextType } from './ChatIdContext.js';

// Chat data context for centralized state management
export { ChatDataProvider, useChatData } from './ChatDataContext.js';
export type { ChatDataContextType } from './ChatDataContext.js';

// Entity context for entity-focused chats
export { EntityContextProvider, useMeridianEntityContext, useMeridianEntityContextOptional } from './EntityContextProvider.js';
export type { MeridianEntityContextData } from './EntityContextProvider.js';